import { Tag, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { PresetColors } from "../../../../common/constants";

interface Props {
  isProcessedManually: boolean;
}

export const ProcessedManuallyMovementTag = ({ isProcessedManually }: Props) => {
  const { t } = useTranslation();

  if (!isProcessedManually) {
    return null;
  }

  return (
    <Tooltip title={t("commissions.bailAccount.helpers.processedManuallyHint")}>
      <Tag color={PresetColors.GREEN} style={{ marginRight: 0 }}>
        {t("commissions.bailAccount.helpers.processedManually")}
      </Tag>
    </Tooltip>
  );
};
